import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';

import MaterialDivider from './MaterialDivider';

const IntermediateLNPSamplesForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, initialValues, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Intermediate LNP Sample'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="LNP Sample Name"
            name={`lnp_sample_name-${data?.index}`}
            value={data?.lnp_sample_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'lnp_sample_name', e.target.value)
            }
            helperText={formErrors[`lnp_sample_name-${data?.index}`]}
            error={`lnp_sample_name-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="LNP Sample Replicate"
            name={`lnp_sample_replicate-${data?.index}`}
            value={data?.lnp_sample_replicate}
            onChange={e => 
              handleInputChange(e, data?.index, 'lnp_sample_replicate', e.target.value)
            }
            helperText={formErrors[`lnp_sample_replicate-${data?.index}`]}
            error={`lnp_sample_replicate-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Encapsulant Phase ID"
            name={`encapsulant_phase_id-${data?.index}`}
            value={data?.encapsulant_phase_id}
            onChange={e => 
              handleInputChange(e, data?.index, 'encapsulant_phase_id', e.target.value)
            }
            helperText={formErrors[`encapsulant_phase_id-${data?.index}`]}
            error={`encapsulant_phase_id-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload Phase ID"
            name={`payload_phase_id-${data?.index}`}
            value={data?.payload_phase_id}
            onChange={e => 
              handleInputChange(e, data?.index, 'payload_phase_id', e.target.value)
            }
            helperText={formErrors[`payload_phase_id-${data?.index}`]}
            error={`payload_phase_id-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={data?.mixer_type}
            onChange={(e, newValue) => 
              handleInputChange(e, data?.index, 'mixer_type', newValue)
            }
            options={initialValues?.mixer_types_list}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Mixer Type" 
                placeholder="Type to search Mixer Type..." 
                error={`mixer_type-${data?.index}` in formErrors}
                helperText={formErrors[`mixer_type-${data?.index}`]}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload concentration after mixing"
            name={`payload_concentration_after_mixing-${data?.index}`}
            value={data?.payload_concentration_after_mixing}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'payload_concentration_after_mixing', e.target.value
              )
            }
            helperText={formErrors[`payload_concentration_after_mixing-${data?.index}`]}
            error={`payload_concentration_after_mixing-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Encapsulant Phase Volume"
            name={`encapsulant_phase_volume-${data?.index}`}
            value={data?.encapsulant_phase_volume}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'encapsulant_phase_volume', e.target.value
              )
            }
            helperText={formErrors[`encapsulant_phase_volume-${data?.index}`]}
            error={`encapsulant_phase_volume-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload Phase Volume"
            name={`payload_phase_volume-${data?.index}`}
            value={data?.payload_phase_volume}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'payload_phase_volume', e.target.value
              )
            }
            helperText={formErrors[`payload_phase_volume-${data?.index}`]}
            error={`payload_phase_volume-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        {
          data?.material_type === 'Janus' && 
          <>
            <Grid item xs={6}>
              <TextField
                varient="outlined"
                label="Ratio C Payload Phase to Encapsulant Phase"
                name={`ratio_c_payload_phase_to_encapsulant_phase-${data?.index}`}
                value={data?.ratio_c_payload_phase_to_encapsulant_phase}
                onChange={e => 
                  handleInputChange(
                    e, data?.index, 'ratio_c_payload_phase_to_encapsulant_phase', e.target.value
                  )
                }
                helperText={formErrors[`ratio_c_payload_phase_to_encapsulant_phase-${data?.index}`]}
                error={`ratio_c_payload_phase_to_encapsulant_phase-${data?.index}` in formErrors}
                type='number'
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                varient="outlined"
                label="Ratio R Encapsulant Phase to Payload Phase"
                name={`ratio_r_encapsulant_phase_to_payload_phase-${data?.index}`}
                value={data?.ratio_r_encapsulant_phase_to_payload_phase}
                onChange={e => 
                  handleInputChange(
                    e, data?.index, 'ratio_r_encapsulant_phase_to_payload_phase', e.target.value
                  )
                }
                helperText={formErrors[`ratio_r_encapsulant_phase_to_payload_phase-${data?.index}`]}
                error={`ratio_r_encapsulant_phase_to_payload_phase-${data?.index}` in formErrors}
                type='number'
                fullWidth
              />
            </Grid>
          </>
        }

        {
          data?.material_type === 'Ignite' && 
          <>
            <Grid item xs={6}>
              <TextField
                varient="outlined"
                label="Flow Rate Ratio C Payload Phase to Encapsulant Phase"
                name={`flow_rate_ratio_c_payload_phase_to_encapsulant_phase-${data?.index}`}
                value={data?.flow_rate_ratio_c_payload_phase_to_encapsulant_phase}
                onChange={e => 
                  handleInputChange(
                    e, data?.index, 'flow_rate_ratio_c_payload_phase_to_encapsulant_phase', e.target.value
                  )
                }
                helperText={formErrors[`flow_rate_ratio_c_payload_phase_to_encapsulant_phase-${data?.index}`]}
                error={`flow_rate_ratio_c_payload_phase_to_encapsulant_phase-${data?.index}` in formErrors}
                type='number'
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                varient="outlined"
                label="Flow Rate Ratio R Encapsulant Phase to Payload Phase"
                name={`flow_rate_ratio_r_encapsulant_phase_to_payload_phase-${data?.index}`}
                value={data?.flow_rate_ratio_r_encapsulant_phase_to_payload_phase}
                onChange={e => 
                  handleInputChange(
                    e, data?.index, 'flow_rate_ratio_r_encapsulant_phase_to_payload_phase', e.target.value
                  )
                }
                helperText={formErrors[`flow_rate_ratio_r_encapsulant_phase_to_payload_phase-${data?.index}`]}
                error={`flow_rate_ratio_r_encapsulant_phase_to_payload_phase-${data?.index}` in formErrors}
                type='number'
                fullWidth
              />
            </Grid>
          </>
        }
      </Grid>
    </Box>
  );
};

IntermediateLNPSamplesForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default IntermediateLNPSamplesForm;